import { aswGetInstanceId } from "../platform/wix";

export function acpSetColorVariables({
    headerbg,
    headerfg,
    contentbg,
    contentfg,
}) {
    // set property on the asw-menu element like the :root
    document.documentElement.style.setProperty('--acp-color-headerbg', headerbg);
    document.documentElement.style.setProperty('--acp-color-headerfg', headerfg);
    document.documentElement.style.setProperty('--acp-color-contentbg', contentbg);
    document.documentElement.style.setProperty('--acp-color-contentfg', contentfg);
    document.documentElement.style.setProperty('--acp-color-buttonbg', headerbg);
    document.documentElement.style.setProperty('--acp-color-buttonfg', headerfg);
}

export function acpSetFontVariables() {
    document.querySelectorAll(":not(.asw-menu, .asw-menu *, .asw-widget, .asw-widget *, html, head, head *, meta, meta *, link, link *, script, script *, style, title)").forEach(el => {
        const orgTextAlign = el.style["text-align"];
        const orgColor = el.style["color"];
        const orgBgColor = el.style.backgroundColor;
        const orgFilter = el.style.filter;
        const orgBgNotImg = window.getComputedStyle(el).getPropertyValue("background-image");
        const orgFontSize = parseFloat(window.getComputedStyle(el).getPropertyValue("font-size"));
        const orgLineHeight = parseFloat(window.getComputedStyle(el).getPropertyValue("line-height"));
        const orgLetterSpacing = parseFloat(window.getComputedStyle(el).getPropertyValue("letter-spacing"));
        el.setAttribute("data-asw-orgTextAlign", orgTextAlign);
        el.setAttribute("data-asw-orgColor", orgColor);
        el.setAttribute("data-asw-orgBgColor", orgBgColor);
        el.setAttribute("data-asw-orgFontSize", orgFontSize);
        el.setAttribute("data-asw-orgLineHeight", orgLineHeight);
        el.setAttribute("data-asw-orgLetterSpacing", orgLetterSpacing);
        el.setAttribute("data-asw-orgFilter", orgFilter);
        if (orgBgNotImg && !orgBgNotImg.includes("url(")) {
            el.setAttribute("data-asw-orgBgNotImg", orgBgNotImg);
        }
    });
}

export const checkIfAnyFeatureActive = () => {
    let anyActive = false;

    accessProFeatures.forEach(feature => {
        if (feature.isActive) {
            anyActive = true;
            return;
        }
    });

    if (!anyActive) {
        const shortcutBtn = document.querySelector('#acp-shortcut-button');
        if (shortcutBtn && shortcutBtn.classList.contains('active')) {
            anyActive = true;
        }
    }

    const activeIcon = document.querySelector('.asw-active-check');
    if (!activeIcon) return;
    if (anyActive) {
        // remove ckass name asw-feature-not-active 
        activeIcon.classList.remove('asw-feature-not-active');
    } else {
        // add class name asw-feature-not-active
        activeIcon.classList.add('asw-feature-not-active');
    }
}

export function aswFeaturesUsageUpdate(featureHandle) {
    // We still track basic engagement (e.g. widget open/close) on free plans so
    // merchant analytics isn't empty. Premium feature gating should be enforced
    // elsewhere (feature availability), not by dropping analytics events.
    if (accessProPlanName === "free" && featureHandle !== "widget-open" && featureHandle !== "widget-close") {
        return;
    }

    if (!featureHandle || typeof featureHandle !== 'string') {
        return;
    }

    let feature = featureHandle;
    if (feature.includes("-")) {
        feature = feature.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
    }

    if (analyticsUsageData[feature]) {
        analyticsUsageData[feature]++;
    } else {
        analyticsUsageData[feature] = 1;
    }
    // Accumulate only — flush on tab hide / unload / interval (session-style)
}

// Send batched analytics data to server
export async function sendBatchedAnalytics() {
    if (Object.keys(analyticsUsageData).length === 0) {
        return;
    }

    if (isSendingAnalytics) {
        return;
    }

    isSendingAnalytics = true;

    try {
        const response = await fetch(`${accessProProxyHandle}/theme/batch-analytics`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                instance_id: aswGetInstanceId(),
                analyticsData: analyticsUsageData
            })
        });

        if (response.ok) {
            const result = await response.json();
            // Clear the local data after successful send
            Object.keys(analyticsUsageData).forEach(key => delete analyticsUsageData[key]);
        } else {
            console.error("Failed to send analytics data:", response.status);
        }
    } catch (error) {
        console.error("Error sending analytics data:", error);
    } finally {
        isSendingAnalytics = false;
    }
}

// Debounced version to prevent rapid successive calls
export function debouncedSendAnalytics() {
    if (analyticsTimeout) {
        clearTimeout(analyticsTimeout);
    }

    analyticsTimeout = setTimeout(() => {
        sendBatchedAnalytics();
    }, 100); // 100ms debounce
}

// Send analytics data when page is about to unload
export function setupAnalyticsCleanup() {
    // Send data before page unload
    window.addEventListener('beforeunload', () => {
        // Use sendBeacon for more reliable delivery during page unload
        if (Object.keys(analyticsUsageData).length > 0 && !isSendingAnalytics) {
            const data = JSON.stringify({ instance_id: aswGetInstanceId(), analyticsData: analyticsUsageData });
            navigator.sendBeacon(`${accessProProxyHandle}/theme/batch-analytics`, data);
            Object.keys(analyticsUsageData).forEach(key => delete analyticsUsageData[key]);
        }
    });

    // Also send data periodically (every 5 minutes) to avoid data loss
    setInterval(() => {
        if (Object.keys(analyticsUsageData).length > 0) {
            sendBatchedAnalytics();
        }
    }, 5 * 60 * 1000); // 5 minutes

    // Send data when visibility changes (user switches tabs/apps, but not when closing)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden && Object.keys(analyticsUsageData).length > 0) {
            if (!isSendingAnalytics) {
                sendBatchedAnalytics();
            }
        }
    });
}

/**
 * Shows a spinner on a feature's icon and disables the feature button
 * @param {HTMLElement} featureElement - The feature button element
 */
export function showFeatureSpinner(featureElement) {
    if (!featureElement) return;

    // Check if spinner already exists
    const existingSpinner = featureElement.querySelector('.acp-loader-button');
    if (existingSpinner) return;

    // Disable the button to prevent double-clicks
    featureElement.style.pointerEvents = 'none';
    featureElement.classList.add('acp-feature-loading');

    // Create spinner element
    const spinner = document.createElement('div');
    spinner.classList.add('acp-loader-button');
    spinner.style.cssText = `
        border-top: 3px solid #ffffff;
        border-right: 3px solid var(--acp-color-contentfg);
        border-bottom: 3px solid #ffffff;
        border-left: 3px solid var(--acp-color-contentfg);
        border-radius: 50%;
        width: 30px;
        height: 30px;
        position: relative;
        display: inline-block;
    `;

    // Add spinner to the feature icon
    const featureIcon = featureElement.querySelector('.acp-feature-icon');
    if (featureIcon) {
        featureIcon.appendChild(spinner);
    }
}

/**
 * Hides the spinner from a feature's icon and re-enables the feature button
 * @param {HTMLElement} featureElement - The feature button element
 */
export function hideFeatureSpinner(featureElement) {
    if (!featureElement) return;

    // Re-enable the button
    featureElement.style.pointerEvents = '';
    featureElement.classList.remove('acp-feature-loading');

    // Remove spinner
    const spinner = featureElement.querySelector('.acp-loader-button');
    if (spinner) {
        spinner.remove();
    }
}